import { motion } from 'framer-motion';

export default function WaveformLoader({ size = 'md', className = '' }) {
  const heights = [10, 18, 24, 16, 22, 12, 20];
  const bar = size === 'sm' ? 'w-[3px]' : size === 'lg' ? 'w-1.5' : 'w-1';
  const max = size === 'sm' ? 16 : size === 'lg' ? 36 : 24;
  return (
    <div
      className={`inline-flex items-end gap-[3px] ${className}`}
      role="status"
      aria-label="Loading"
      data-testid="waveform-loader"
    >
      {heights.map((h, i) => (
        <motion.span
          key={`bar-${i}-${h}`}
          className={`${bar} rounded-sm bg-[hsl(var(--primary))]/80`}
          style={{ height: max }}
          initial={{ scaleY: 0.3, opacity: 0.5 }}
          animate={{ scaleY: [0.3, 1, 0.4], opacity: [0.5, 1, 0.6] }}
          transition={{
            duration: 0.9,
            repeat: Infinity,
            delay: i * 0.08,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
}
